import { createContext, useContext } from 'react';
import type { DBContextType } from '../types/app';

// Minimal default context to avoid undefined checks in consumers. Real values
// are populated by DBProvider.
export const DBContext = createContext<DBContextType>({
  db: null,
  message: '',
  loading: true,
  setMessage: () => {},
  setLoading: () => {},
  setDocument: async () => {}
});

export const useDB = () => {
  const context = useContext(DBContext);
  if (context === undefined) {
    throw new Error('useDB must be used within a DBProvider');
  }
  return context;
};
